import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Stock twMerge reads the theme's type-scale utilities (`text-label`, `text-caption`, ...)
// as text colours, so `cn("text-caption", "text-ink-muted")` would drop the size.
// Registered as font sizes, both survive.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["heading-lg", "heading-md", "heading-sm", "label", "body", "body-long", "caption", "overline", "micro"] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
